/* ==========================================================================
   Incipit - Bloc texte centre - reveal animations
   - IntersectionObserver pour declencher fade + translate
   - One-shot, respecte prefers-reduced-motion
   - Delai par element via data-reveal-delay (en ms)
   ========================================================================== */

(function () {
  'use strict';

  function initReveal(section) {
    var elements = section.querySelectorAll('[data-reveal]');
    if (elements.length === 0) return;

    // Fallback : pas d'IntersectionObserver -> tout reveler immediatement
    if (typeof IntersectionObserver === 'undefined') {
      elements.forEach(function (el) {
        el.classList.add('is-revealed');
      });
      return;
    }

    // Reduced motion : afficher direct, pas d'animation
    var prefersReducedMotion = window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (prefersReducedMotion) {
      elements.forEach(function (el) {
        el.classList.add('is-revealed');
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var delay = parseInt(el.dataset.revealDelay, 10) || 0;
        setTimeout(function () {
          el.classList.add('is-revealed');
        }, delay);
        observer.unobserve(el);
      });
    }, {
      threshold: 0.05,
      rootMargin: '0px 0px -10% 0px'
    });

    elements.forEach(function (el) {
      observer.observe(el);
    });
  }

  function initSection(section) {
    if (!section || section.dataset.incipitTbInit === 'true') return;
    section.dataset.incipitTbInit = 'true';
    initReveal(section);
  }

  function initAll() {
    document.querySelectorAll('.incipit-tb').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init quand la section recharge dans l'editeur Shopify
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.incipit-tb');
    if (section) initSection(section);
  });
})();